import React from "react";
import { Tooltip } from "antd";

const CustomTooltip = ({ children, title, placement }) => (
  <Tooltip title={title} {...(placement ? { placement } : {})}>
    {children}
  </Tooltip>
);

export default CustomTooltip;
